import React, { useEffect, useState, useContext } from "react";
import _ from "lodash";
import Form from "forms/Form";
import MainContext from "context/MainContext";
import { CALENDARS, CERTIFICATES, EVENTS } from "api/config/endpoints";
import formWrapper from "hoc/formWrapper";
import { buildQuery, getCalendar, getEventCalendarByType } from "api/functions/functions";
import useEventHandler from "hooks/useEventHandler";
import { Loading } from "carbon-components-react";
import { DISABLE_EPISODE, ON_DEMAND_EVENT, SUNSET } from "api/config/calendarTypes";
import { consoleLog } from "utils/functions";
import { SCHEDULE_CERTIFICATE_DELIVERY, SCHEDULE_CERTIFICATE_REMINDER } from "config/calendarTypes";
import {InlineNotification} from "carbon-components-react";

const CalendarForm = (props) => {
    const context = useContext(MainContext)

    const [loaded, setLoaded] = useState(false);
    const [saving, setSaving] = useState(false);
    const [event, setEvent] = useState();
    const [defaultValues, setDefaultValues] = useState({});
    const [calendarType, setCalendarType] = useState();

    const {
        _loadEventData
    } = useEventHandler()

    useEffect(() => {
        if (_.isEmpty(context.evt)) {
            return false
        }
        setEvent(context.evt.id)
    }, [context.evt])

    useEffect(() => {
        if (!calendarType || !event || props.createNewCalendar) {
            setLoaded(true);
            return
        }
        loadData(calendarType)
    }, [calendarType, event, props.createNewCalendar])

    useEffect(() => {
        if (!props.calendarType) { return }
        setCalendarType(props.calendarType)
    }, [props.calendarType])

    const loadData = async (eventType) => {
        let res = null
        if (props.createNewCalendar) {
            res = {}
        }
        else if (props.selectedCalendar) {
            res = props.selectedCalendar
        }
        else if (props.selectedCalendarId) {
            res = await getCalendar(props.selectedCalendarId);
        }
        else {
            res = await getEventCalendarByType(event, eventType, context.episodeId);
        }

        consoleLog("loadData", res)
        try {
            if (res) {
                setDefaultValues(res);
                setLoaded(true);
            }
        }
        catch (e) {
            setLoaded(true);
        }
    }

    const getValue = (name, type) => {
        const value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;
        switch (type) {
            case "bool":
                return (value !== 0 && value !== null && value !== undefined);
            default:
                return value;
        }
    };

    const getEndpoint = () => {
        let endpoint = ""
        const endpointParams = buildQuery({
            type: calendarType,
            episode_id: context.episodeId
        })
        if (props.createNewCalendar) {
            endpoint = `${CERTIFICATES}/${props.parentId}/${CALENDARS}?${endpointParams}`;
        }
        else if (props.itemId) {
            endpoint = `${CALENDARS}`;
        }
        else {
            endpoint = `${EVENTS}/${event}/${CALENDARS}?${endpointParams}`;
        }

        return `${endpoint}`
    }

    const onSubmit = async () => {
        consoleLog("client.get onSubmit")
        _loadEventData()
        // loadItems()

        if (props.onSubmit) {
            props.onSubmit()
        }
    }

    const getStartFieldLabel = () => {
        let label = ""

        switch (calendarType) {
            case SCHEDULE_CERTIFICATE_REMINDER:
            case SCHEDULE_CERTIFICATE_DELIVERY:
                label = "Send at"
                break
            case SUNSET:
                label = "Detach at"
                break
            default:
                label = "Start at"
        }
        return label
    }

    let fields = 1
        ? [
            {
                elementType: "datetime",
                id: "start_at",
                name: "start_at",
                // invalidText: "Invalid error message.",
                labelText: `${getStartFieldLabel()} (${context.evt.timezone})`,
                value: getValue("start_at"),
                timepicker: true,
                timezone: context.evt.timezone
            },
            {
                elementType: "hidden",
                id: "type",
                name: "type",
                value: calendarType,
            },

        ]
        : [];

    if (![
        ON_DEMAND_EVENT,
        SUNSET,
        SCHEDULE_CERTIFICATE_REMINDER,
        SCHEDULE_CERTIFICATE_DELIVERY
    ].includes(calendarType)) {
        // if (calendarType !== ON_DEMAND_EVENT && calendarType !== SUNSET) {
        fields.push({
            elementType: "datetime",
            id: "finish_at",
            name: "finish_at",
            // invalidText: "Invalid error message.",
            labelText: `Finish at (${context.evt.timezone})`,
            value: getValue("finish_at"),
            timepicker: true,
            timezone: context.evt.timezone
        })
    }
    else if (calendarType === ON_DEMAND_EVENT) {
        fields.push({
            elementType: "datetime",
            id: "fake_start_at",
            name: "fake_start_at",
            // invalidText: "Invalid error message.",
            labelText: `FAKE Start at (${context.evt.timezone})`,
            value: getValue("fake_start_at"),
            timepicker: true,
            timezone: context.evt.timezone
        })
        fields.push({
            elementType: "help",
            id: "help",
            content: (
                <div>
                    <p>VOD end time depends on every single channel.</p>
                    <p>It will be calcuated using proper channel <strong>"On Demand Hrs"</strong> field value</p>
                    <p>Example: "Start at" + 24, 48 or 72 Hrs</p>
                    <p><strong>FAKE Start at</strong> is for display purposes only. No function is based on this data. Leave blank to show <strong>Start at</strong></p>
                </div>
            )
        })
    }
    else if ([
        SCHEDULE_CERTIFICATE_REMINDER,
        SCHEDULE_CERTIFICATE_DELIVERY
    ].includes(calendarType)) {
        fields.push({
            elementType: "toggle",
            id: "is_forced",
            name: "is_forced",
            labelText: "Force",
            value: getValue("is_forced", "bool"),
            labelOff: (
                <>
                    <div>Force disabled. It will only be sent to users who have not yet received it.</div>
                    <div>Toggle to send it to everyone</div>
                </>
            ), //labelA
            labelOn: (
                <>
                    <div>Force anabled. Everyone will receive it.</div>
                    <div>Toggle to send only to users who have not yet received it</div>
                </>
            ), //labelB
        })
    }

    const onChange = (key, value) => {
        setDefaultValues({
            ...defaultValues,
            [key]: value
        });
    }

    const onSavingChange = (value) => {
        setSaving(value)
    }

    const defaultParams = () => {
        let params = (!DISABLE_EPISODE.includes(calendarType)) ? {
            episode_id: context.episodeId
        } : {}
        if (props.parentId) {
            params = {
                ...params,
                parent_id: props.parentId
            }
        }
        return params
    }

    return (
        <div className={props.className}>
            {
                saving ? <Loading /> : null
            }
            <Form
                blockTouched={false}
                itemId={props.itemId}
                fields={fields}
                endpoint={getEndpoint()}
                loaded={loaded}
                modal={props.modal}
                onRequestClose={props.onRequestClose}
                onSavingChange={(value) => onSavingChange(value)}
                // setAutoId={true}
                // saveOnChange={true}
                // hideSubmitButton={true}
                onChange={(key, val) => onChange(key, val)}
                defaultParams={defaultParams()}
                onSubmit={() => onSubmit()}
                extraFieldsAfter={defaultValues.is_holiday ? <InlineNotification kind="error" lowContrast hideCloseButton={true} title="ATTENTION, the date chosen includes weekends or holidays"/> : null}
            // key={"form-" + itemId}
            />
        </div>
    );
};

export default formWrapper(CalendarForm);
